import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    resetPosition: translate({ id: 'lib.locationEditor.modal.resetPosition' }),
  }))

  return api
}
